import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  FormGroup,
  MenuItem,
  Select,
  FormControl,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import config from "../../config.js";
import SubTitle from "../common/SubTitle";
import RejectModal from "./RejectModal";
import axios from "axios";
import { useUser } from "../../pages/login/UserContextPersistent";
import LocationPin from "../../images/LocationPin.svg";
import ArrowDownward from "../../images/table/Arrow_down.svg";
import { useTranslation } from "react-i18next";

axios.defaults.withCredentials = true;

export const isRouteEyeAdmin = () => {
  const userState = localStorage.getItem("userState");
  if (!userState) return false;
  try {
    const user = JSON.parse(userState).user;
    return user.organizationId === 5 && user.email === "sales@routeeye.io";
  } catch {
    return false;
  }
};

export default function AdminOrgMoreMain() {
    const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const currentPath = location.pathname;
  const { state: userState } = useUser();

  const isAdmin = isRouteEyeAdmin();
  // console.log(isAdmin, "aloooooooooo");

  const selectedOrganization = location.state?.selectedOrganization || {};
  const requestId = location.state?.requestId || null;

  const [loading, setLoading] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [orgId, setOrgId] = useState(null);
  const [requirementId, setRequirementId] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState(
    selectedOrganization?.approvalStatus
  );
  const [formData, setFormData] = useState({
    totalVehicles: "",
    totalStops: "",
    totalRoutes: "",
    totalSites: "",
    totalDrivers: "",
    totalUsers: "",
    dataRetention: "30",
    dataImportExport: "pdf",
    trackingFrequency: "5",
    displayScreenType: "led",
    goLiveDate: "",
    networkRequirement: { GSM: false, GPS: false, Satellite: false },
    hasCloudInfrastructure: "",
    cloudDetails: "",
    needsSupport: "",
    specificNeeds: "",
  });
  const [errors, setErrors] = useState({});
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [orgNameToReject, setOrgNameToReject] = useState(
    selectedOrganization?.name || ""
  );

  const isRequestView = currentPath.startsWith("/request/");

  useEffect(() => {
    if (selectedOrganization?.approvalStatus) {
      setApprovalStatus(selectedOrganization.approvalStatus);
    }

    const organizationId =
      id || selectedOrganization?.organizationId || selectedOrganization?.id;

    if (organizationId) {
      setOrgId(organizationId);

      fetchRequirements(organizationId);
    } else {
      console.error("No organization ID available");
      setNotification({
        open: true,
        message: "No organization ID available",
        severity: "error",
      });
      navigate("/dashboard");
    }
  }, [id, selectedOrganization, navigate]);

  const fetchRequirements = async (organizationId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.baseURL}/requirements/organization/${organizationId}`
      );
      const data = response.data;
      const req =
        data?.requirement ||
        data?.requirements?.[0] ||
        (Array.isArray(data) ? data[0] : data) ||
        {};
      if (req && Object.keys(req).length > 0) {
        const networkRequirements =
          req.networkRequirements ||
          req.OrganizationRequirementToNetworkReq?.map((item) => item.B) || [];
        const normalizedNetworkReqs = networkRequirements.map((value) =>
          String(value || "").toUpperCase()
        );
        setRequirementId(req.id);
        setFormData({
          totalVehicles: String(req.totalNoOfVehicles || ""),
          totalStops: String(req.totalNoOfStops || ""),
          totalRoutes: String(req.totalNoOfRoutes || ""),
          totalSites: String(req.totalNoOfSites || ""),
          totalDrivers: String(req.totalNoOfDrivers || ""),
          totalUsers: String(req.totalNoOfSysUsers || ""),
          dataRetention: String(req.retentionPeriod || ""),
          dataImportExport:
            (req.dataImportType ||
              req.OrganizationRequirementToDataImport?.[0]?.B ||
              "pdf")
              .toLowerCase(),
          trackingFrequency: String(req.trackingFreq || ""),
          displayScreenType:
            req.screenType?.toLowerCase() === "nodisplay"
              ? "none"
              : req.screenType?.toLowerCase() || "",
          goLiveDate: req.goLiveDate ? req.goLiveDate.split("T")[0] : "",
          networkRequirement: {
            GSM: normalizedNetworkReqs.includes("GSM"),
            GPS: normalizedNetworkReqs.includes("GPS"),
            Satellite: normalizedNetworkReqs.includes("SATELLITE"),
          },
          hasCloudInfrastructure: req.ownCloudInfra ? "yes" : "no",
          cloudDetails: req.ownCloudDetails || "",
          needsSupport: req.maintainenceSupprt ? "yes" : "no",
          specificNeeds: req.tellUsMore || "",
        });
      }
    } catch (error) {
      console.error("Error fetching requirements:", error);
      setNotification({
        open: true,
        message: error.response?.data?.message || "Failed to load requirements",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderRadius: "16px",
        border: "1px solid #183059",
        height: "43px",
      },
      "&:hover fieldset": { borderColor: "#183059" },
      "&.Mui-focused fieldset": { borderColor: "#183059" },
    },
  };

  const labelStyle = {
    width: "50%",
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "20px",
    pr: 1,
    color: "#414958",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      networkRequirement: {
        ...prev.networkRequirement,
        [name]: checked,
      },
    }));
  };

  const transformFormData = () => {
    const screenTypeMap = { led: "LED", lcd: "LCD", none: "NODISPLAY" };
    const dataImportType = formData.dataImportExport
      ? formData.dataImportExport.toUpperCase()
      : null;
    const baseData = {
      organizationId: Number(orgId),
      totalNoOfVehicles: parseInt(formData.totalVehicles) || 0,
      totalNoOfStops: parseInt(formData.totalStops) || 0,
      totalNoOfRoutes: parseInt(formData.totalRoutes) || 0,
      totalNoOfSites: parseInt(formData.totalSites) || 0,
      totalNoOfDrivers: parseInt(formData.totalDrivers) || 0,
      totalNoOfSysUsers: parseInt(formData.totalUsers) || 0,
      retentionPeriod: parseInt(formData.dataRetention),
      trackingFreq: parseInt(formData.trackingFrequency),
      screenType: screenTypeMap[formData.displayScreenType],
      goLiveDate: formData.goLiveDate
        ? new Date(formData.goLiveDate).toISOString()
        : null,
      ownCloudInfra: formData.hasCloudInfrastructure === "yes",
      ownCloudDetails:
        formData.hasCloudInfrastructure === "yes"
          ? formData.cloudDetails
          : "",
      maintainenceSupprt: formData.needsSupport === "yes",
      tellUsMore: formData.specificNeeds,
    };

    const networkRequirements = Object.entries(formData.networkRequirement)
      .filter(([_, checked]) => checked)
      .map(([name]) => name.toUpperCase());

    return {
      ...baseData,
      networkRequirements,
      dataImportType,
    };
  };

  const submitFormData = async () => {
    if (!orgId) {
      setNotification({
        open: true,
        message: "No organization ID available",
        severity: "error",
      });
      return;
    }

    try {
      setLoading(true);
      const apiData = transformFormData();
      if (requirementId) {
        delete apiData.organizationId;
      }

      const apiUrl = requirementId
        ? `${config.baseURL}/requirements/${requirementId}`
        : `${config.baseURL}/requirements`;
      const method = requirementId ? "put" : "post";

      const response = await axios[method](apiUrl, apiData);

      setSaveSuccess(true);
      // setNotification({
      //   open: true,
      //   message: `Requirements ${
      //     requirementId ? "updated" : "created"
      //   } successfully`,
      //   severity: "success",
      // });
      setTimeout(() => {
        if (isAdmin) {
          navigate("/org");
        } else {
          navigate("/dashboard");
        }
      }, 1500);
    } catch (error) {
      console.error("Error submitting form:", error);
      setNotification({
        open: true,
        message: error.response?.data?.message || "Failed to save requirements",
        severity: "error",
      });
    } finally {
      setLoading(false);
      setTimeout(() => {
        if (isAdmin) {
          navigate("/org");
        } else {
          navigate("/dashboard");
        }
      }, 1500);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const numericFields = [
      "totalVehicles",
      "totalStops",
      "totalRoutes",
      "totalSites",
      "totalDrivers",
      "totalUsers",
    ];

    numericFields.forEach((field) => {
      const value = formData[field];
      if (value !== "" && !/^\d+$/.test(value)) {
        // if (value === "") {
        //   newErrors[field] = "This field is required";
        // } else if (!/^\d+$/.test(value)) {
        newErrors[field] = "Please enter a valid non-negative integer";
      }
    });

    if (formData.goLiveDate) {
      //   newErrors.goLiveDate = "Please select a go-live date";
      // } else {
      const selectedDate = new Date(formData.goLiveDate);
      const today = new Date();
      if (selectedDate <= today) {
        newErrors.goLiveDate = "Go-live date must be in the future";
      }
    }

    // const { wifi, cellular, ethernet } = formData.networkRequirement;
    // if (!wifi && !cellular && !ethernet) {
    //   newErrors.networkRequirement =
    //     "Please select at least one network requirement";
    // }

    // if (!formData.hasCloudInfrastructure) {
    //   newErrors.hasCloudInfrastructure = "Please select an option";
    // } else
    if (
      formData.hasCloudInfrastructure === "yes" &&
      !formData.cloudDetails.trim()
    ) {
      newErrors.cloudDetails =
        "Please provide details about your cloud infrastructure";
    }

    // if (!formData.needsSupport) {
    //   newErrors.needsSupport = "Please select an option";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      await submitFormData();
    } else {
      console.log("Form has validation errors");
    }
  };

  const handleSaveDraft = () => {
    console.log("Saving draft:", formData);
    navigate(-1);
    // localStorage.setItem("requirementDraft", JSON.stringify(formData));
    // setNotification({
    //   open: true,
    //   message: 'Draft saved successfully',
    //   severity: 'success',
    // });
  };

  const hasPermission = (requiredPath, requiredAction) => {
    if (!userState?.features) {
      return false; // Default to no permission if features are not available
    }
    return userState.features.some((feature) => {
      return (
        feature.api_path === requiredPath && feature.action === requiredAction
      );
    });
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleReject = () => {
    setRejectModalOpen(true);
  };

  const confirmReject = async () => {
    setIsActionLoading(true);
    try {
      const targetId = isRequestView
        ? requestId || location.state?.selectedOrganization?.id
        : location.state?.selectedOrganization?.id;
      await axios.post(`${config.baseURL}/register/${targetId}/reject`, {
        reason: rejectionReason,
      });
      setRejectModalOpen(false);
      setApprovalStatus("REJECTED");
      setNotification({
        open: true,
        message: "Organization rejected successfully",
        severity: "success",
      });
      setTimeout(() => navigate("/admin"), 1500);
    } catch (error) {
      console.error("Error rejecting request:", error);
      setNotification({
        open: true,
        message: error.response?.data?.msg || "Failed to reject organization",
        severity: "error",
      });
      setRejectModalOpen(false);
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleAccept = async () => {
    setIsActionLoading(true);
    try {
      const targetId = isRequestView
        ? requestId || location.state?.selectedOrganization?.id
        : location.state?.selectedOrganization?.id;
      await axios.post(`${config.baseURL}/register/${targetId}/accept`, {});
      setApprovalStatus("ACCEPTED");
      setNotification({
        open: true,
        message: "Organization approved successfully",
        severity: "success",
      });
      setTimeout(() => navigate("/admin"), 1500);
    } catch (error) {
      console.error("Error accepting request:", error);
      setNotification({
        open: true,
        message: error.response?.data?.msg || "Failed to approve organization",
        severity: "error",
      });
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleSave = async () => {
    console.log("Saving request...");
    await submitFormData();
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  const FormField = ({ label, width = "50%", children, required, error }) => (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <InputLabel sx={{ ...labelStyle, width }}>
        {label}
        {/* {required && (
          <Box component="span" sx={{ ml: 1, color: "#EE3B2B" }}>
            *
          </Box>
        )} */}
      </InputLabel>
      <Box sx={{ width }}>
        {children}
        {error && (
          <Typography color="error" variant="caption">
            {error}
          </Typography>
        )}
      </Box>
    </Box>
  );

  let actionButtons;

  if (isRequestView) {
    if (approvalStatus === "REJECTED") {
      actionButtons = (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 2,
            mb: 1,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleCancel}
            sx={{
              minWidth: 100,
              height: 55,
              borderRadius: "8px",
              background: "#F2F2F3",
              border: "1px solid #414958",
              color: "#1F242E",
              fontFamily: "Roboto",
              fontWeight: "500",
              fontSize: "20px",
              textTransform: "none",
            }}
          >
            {t("Cancel")}
          </Button>
          <Button
            variant="outlined"
            onClick={handleSave}
            sx={{
              minWidth: 100,
              height: 55,
              borderRadius: "8px",
              background: "#F9E719",
              border: "1px solid #414958",
              color: "#111214",
              fontFamily: "Roboto",
              fontWeight: "500",
              fontSize: "20px",
              textTransform: "none",
              ":hover": { background: "#F9E719" },
            }}
          >
            {t("Save")}
          </Button>
          <Button
            variant="contained"
            onClick={handleAccept}
            disabled={isActionLoading}
            sx={{
              minWidth: 100,
              height: 55,
              borderRadius: "8px",
              background: "#F9E719",
              border: "1px solid #414958",
              color: "#111214",
              fontFamily: "Roboto",
              fontWeight: "500",
              fontSize: "20px",
              textTransform: "none",
              ":hover": { background: "#F9E719" },
            }}
          >
            {isActionLoading ? <CircularProgress size={24} /> : t("Accept")}
          </Button>
        </Box>
      );
    } else {
      actionButtons = (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 2,
            mb: 1,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleReject}
            disabled={isActionLoading}
            sx={{
              minWidth: 100,
              height: "55px",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "20px",
              background: "#EE3B2B",
              border: "1px solid #414958",
              color: "#FFFFFF",
              fontFamily: "Roboto",
              fontSize: "20px",
              textTransform: "none",
              ":hover": { background: "#EE3B2B" },
            }}
          >
            {isActionLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              t("Reject")
            )}
          </Button>
          <Button
            variant="outlined"
            onClick={handleCancel}
            sx={{
              minWidth: 100,
              height: 55,
              borderRadius: "8px",
              background: "#F2F2F3",
              border: "1px solid #414958",
              color: "#1F242E",
              fontFamily: "Roboto",
              fontWeight: 600,
              fontSize: "20px",
              textTransform: "none",
            }}
          >
            {t("Cancel")}
          </Button>
          <Button
            variant="outlined"
            onClick={handleSave}
            sx={{
              minWidth: 100,
              height: 55,
              borderRadius: "8px",
              background: "#F9E719",
              border: "1px solid #414958",
              color: "#111214",
              fontFamily: "Roboto",
              fontWeight: 600,
              fontSize: "20px",
              textTransform: "none",
              ":hover": { background: "#F9E719" },
            }}
          >
            {t("Save")}
          </Button>
          <Button
            variant="contained"
            onClick={handleAccept}
            disabled={isActionLoading}
            sx={{
              minWidth: 100,
              height: 55,
              borderRadius: "8px",
              background: "#F9E719",
              border: "1px solid #414958",
              color: "#111214",
              fontFamily: "Roboto",
              fontWeight: 600,
              fontSize: "20px",
              textTransform: "none",
              ":hover": { background: "#F9E719" },
            }}
          >
            {isActionLoading ? <CircularProgress size={24} /> : t("Accept")}
          </Button>
        </Box>
      );
    }
  } else {
    actionButtons = hasPermission("/api/user/organization", "PATCH") && (
      <Box
        sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 2, mb: 1 }}
      >
        <Button
          variant="outlined"
          color="primary"
          sx={{
            width: "240px",
            height: "55px",
            borderRadius: "8px",
            borderWidth: 1,
            padding: "16px 24px",
            border: "1px solid #414958",
            backgroundColor: "#FFFFFF",
            color: "#414958",
            fontFamily: "Roboto",
            fontSize: "20px",
            fontWeight: 600,
            textTransform: "none",
          }}
          onClick={handleSaveDraft}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : t("Cancel")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          sx={{
            width: "240px",
            height: "55px",
            borderRadius: "8px",
            borderWidth: 1,
            padding: "16px 24px",
            backgroundColor: "#F9E719",
            color: "#111214",
            fontFamily: "Roboto",
            fontSize: "20px",
            fontWeight: 600,
            border: "1px solid #414958",
            "&:hover": { background: "#F9E719" },
            textTransform: "none",
          }}
          onClick={handleSubmit}
          disabled={loading || !orgId}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : requirementId ? (
            (t("Request Changes"))
          ) : (
            t("Save")
          )}
        </Button>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <CircularProgress />
        <Typography>{t("Loading...")}</Typography>
      </Box>
    );
  }

  if (saveSuccess) {
    const orgName = JSON.parse(localStorage.getItem("userState"))?.organization
      ?.name;
    return (
      <>
        {" "}
        <SubTitle
          title="Organization Requirements"
          path={
            isRequestView
              ? `${
                  orgName || "organization"
                }> New Request > Assign Feature >View More`
              : !isAdmin
              ? `${
                  orgName || "organization"
                } > Organization Profile > Organization Features > View More`
              : `${
                  orgName || "organization"
                } > Update Organization > Assign Features > Organization Requirements`
          }
        />
        <Box sx={{ p: 4, textAlign: "center" }}>
          <Typography variant="h6" color="success.main">
            Requirements {requirementId ? "updated" : "created"} successfully!
          </Typography>
        </Box>
      </>
    );
  }

  const orgName = JSON.parse(localStorage.getItem("userState"))?.organization
    ?.name;

  return (
    <>
      {approvalStatus === "REJECTED" && (
        <Box
          sx={{
            backgroundColor: "#EE3B2B",
            height: "36px",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            fontFamily: "Roboto",
            fontWeight: 600,
            fontSize: "24px",
            color: "#FFFFFF",
          }}
        >
          Application Rejected
        </Box>
      )}
      <SubTitle
        title="Organization Requirements"
        path={
          isRequestView
            ? `${
                orgName || "organization"
              }> New Request > Assign Feature >View More`
            : !isAdmin
            ? `${
                orgName || "organization"
              } > Organization Profile > Organization Features > View More`
            : `${
                orgName || "organization"
              } > Update Organization > Assign Features > Organization Requirements`
        }
      />
      <Box sx={{ padding: "0px 40px" }}>
        <Box
          sx={{
            padding: "40px",
            borderRadius: "10px",
            background: "#FFFFFF",
            border: "1px solid #A5DCF3",
            boxShadow: "-2px 2px 5px 0px #00000040",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          <Box sx={{ px: { xs: 0, sm: 2 } }}>
            <Grid container spacing={3}>
              {[
                {
                  name: "totalVehicles",
                  label: "Total No. of vehicles to track",
                  placeholder: "Enter number of vehicles",
                },
                {
                  name: "totalStops",
                  label: "Total No. of stops to track",
                  placeholder: "Enter number of stops",
                },
                {
                  name: "totalRoutes",
                  label: "Total No. of routes to track",
                  placeholder: "Enter number of routes",
                },
                {
                  name: "totalSites",
                  label: "Total No. of sites to manage",
                  placeholder: "Enter number of sites",
                },
                {
                  name: "totalDrivers",
                  label: "Total No. of drivers to manage",
                  placeholder: "Enter number of drivers",
                },
                {
                  name: "totalUsers",
                  label: "Total No. of system users",
                  placeholder: "Enter number of system users",
                },
              ].map((field) => (
                <Grid item xs={12} md={6} key={field.name}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <InputLabel sx={{ ...labelStyle }}>
                      {t(field.label)}
                      {/* <Box component="span" sx={{ ml: 1, color: "#EE3B2B" }}>
                        *
                      </Box> */}
                    </InputLabel>
                    <Box sx={{ width: "50%" }}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="text"
                        name={field.name}
                        value={formData[field.name]}
                        onChange={handleChange}
                        placeholder={t(field.placeholder)}
                        InputProps={{
                          sx: {
                            color: "#111214",
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            fontStyle: "Medium",
                            fontWeight: 500,
                          },
                        }}
                        sx={{
                          width: "100%",
                          borderRadius: "16px",
                          ...inputStyle,
                        }}
                        onKeyDown={(e) => {
                          if (
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        disabled={
                          !hasPermission("/api/user/organization", "PATCH")
                        }
                      />
                      {errors[field.name] && (
                        <Typography color="error" variant="caption">
                          {errors[field.name]}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Grid>
              ))}

              <Grid item xs={12} md={6}>
                <FormField label={t("Data retention period")}>
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      size="small"
                      name="dataRetention"
                      value={formData.dataRetention}
                      onChange={handleChange}
                      IconComponent={() => (
                        <img
                          src={ArrowDownward}
                          alt="dropdown"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "12px",
                            pointerEvents: "none",
                          }}
                        />
                      )}
                      sx={{
                        ...inputStyle,
                        displayEmpty: true,
                        borderRadius: "16px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #183059",
                        },
                      }}
                      renderValue={(value) =>
                        value
                          ? t("{{value}} days", { value })
                          : t("Select retention period")
                      }
                      disabled={
                        !hasPermission("/api/user/organization", "PATCH")
                      }
                    >
                      <MenuItem value="7">{t("{{value}} days", { value: 7 })}</MenuItem>
                      <MenuItem value="30">{t("{{value}} days", { value: 30 })}</MenuItem>
                      <MenuItem value="60">{t("{{value}} days", { value: 60 })}</MenuItem>
                      <MenuItem value="120">{t("{{value}} days", { value: 120 })}</MenuItem>
                    </Select>
                  </FormControl>
                </FormField>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormField
                  label={
                    <Typography
                      component="span"
                      sx={{
                        fontSize: "20px",
                        fontWeight: 500,
                        color: "#414958",
                      }}
                    >
                      {t("Data Import/Export")} <br />
                      <span style={{ fontSize: "16px" }}>{t("(PDF/Excel/CSV)")}</span>
                    </Typography>
                  }
                >
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      size="small"
                      name="dataImportExport"
                      value={formData.dataImportExport}
                      onChange={handleChange}
                      IconComponent={() => (
                        <img
                          src={ArrowDownward}
                          alt="dropdown"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "12px",
                            pointerEvents: "none",
                          }}
                        />
                      )}
                      sx={{
                        ...inputStyle,
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #183059",
                          borderRadius: "16px",
                        },
                      }}
                      displayEmpty
                      disabled={
                        !hasPermission("/api/user/organization", "PATCH")
                      }
                      renderValue={(value) => value || t("Select format")}
                    >
                      <MenuItem value="pdf">{t("PDF")}</MenuItem>
                      <MenuItem value="excel">{t("Excel")}</MenuItem>
                      <MenuItem value="csv">{t("CSV")}</MenuItem>
                    </Select>
                  </FormControl>
                </FormField>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormField label={t("Tracking frequency")}>
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      size="small"
                      name="trackingFrequency"
                      value={formData.trackingFrequency}
                      onChange={handleChange}
                      IconComponent={() => (
                        <img
                          src={ArrowDownward}
                          alt="dropdown"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "12px",
                            pointerEvents: "none",
                          }}
                        />
                      )}
                      sx={{
                        ...inputStyle,
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #183059",
                          borderRadius: "16px",
                        },
                      }}
                      displayEmpty
                      disabled={
                        !hasPermission("/api/user/organization", "PATCH")
                      }
                      renderValue={(value) =>
                        value ? t("{{value}} seconds", { value }) : t("Select frequency")
                      }
                    >
                      <MenuItem value="5">{t("{{value}} seconds", { value: 5 })}</MenuItem>
                      <MenuItem value="10">{t("{{value}} seconds", { value: 10 })}</MenuItem>
                    </Select>
                  </FormControl>
                </FormField>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormField
                  label={
                    <Typography
                      component="span"
                      sx={{
                        fontSize: "20px",
                        fontWeight: 500,
                        color: "#414958",
                      }}
                    >
                      {t("Display screen type")} <br />{" "}
                      <span style={{ fontSize: "16px" }}>
                        {t("(LED/LCD/No display)")}
                      </span>
                      <img src={LocationPin} alt="" />
                    </Typography>
                  }
                >
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      size="small"
                      name="displayScreenType"
                      value={formData.displayScreenType}
                      onChange={handleChange}
                      IconComponent={() => (
                        <img
                          src={ArrowDownward}
                          alt="dropdown"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "12px",
                            pointerEvents: "none",
                          }}
                        />
                      )}
                      sx={{
                        ...inputStyle,
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #183059",
                          borderRadius: "16px",
                        },
                      }}
                      displayEmpty
                      disabled={
                        !hasPermission("/api/user/organization", "PATCH")
                      }
                      renderValue={(value) => {
                        if (!value) return t("Select screen type");
                        const options = {
                          led: t("LED"),
                          lcd: t("LCD"),
                          none: t("No Display"),
                        };
                        return options[value];
                      }}
                    >
                      <MenuItem value="led">{t("LED")}</MenuItem>
                      <MenuItem value="lcd">{t("LCD")}</MenuItem>
                      <MenuItem value="none">{t("No Display")}</MenuItem>
                    </Select>
                  </FormControl>
                </FormField>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <InputLabel sx={{ ...labelStyle }}>
                    {t("When do you want system to Go-Live?")}
                  </InputLabel>
                  <Box
                    sx={{
                      position: "relative",
                      width: { xs: "50%", md: "20%" },
                    }}
                  >
                    <TextField
                      variant="outlined"
                      size="small"
                      type="date"
                      name="goLiveDate"
                      value={formData.goLiveDate}
                      onChange={handleChange}
                      error={!!errors.goLiveDate}
                      helperText={errors.goLiveDate}
                      sx={{ width: "100%", ...inputStyle }}
                      disabled={
                        !hasPermission("/api/user/organization", "PATCH")
                      }
                    />
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  <InputLabel
                    sx={{
                      width: "auto",
                      fontWeight: "500",
                      fontSize: "20px",
                      pr: 1,
                      mt: 1,
                      color: "#414958",
                    }}
                  >
                    {t("Network requirement")}
                    <img src={LocationPin} alt="" />
                    <img src={LocationPin} alt="" />
                  </InputLabel>
                  <Box sx={{ width: { xs: "50%", md: "80%" } }}>
                    <FormGroup row>
                      {["GSM", "GPS", "Satellite"].map((option) => (
                        <FormControlLabel
                          key={option}
                          control={
                            <Checkbox
                              name={option}
                              sx={{
                                "&.MuiCheckbox-root": {
                                  color: "#95A0B3",
                                  fontSize: "16px",
                                },
                                "&.MuiCheckbox-root.Mui-checked": {
                                  color: "#20A8E0",
                                },
                              }}
                              checked={formData.networkRequirement[option]}
                              onChange={handleCheckboxChange}
                              disabled={
                                !hasPermission(
                                  "/api/user/organization",
                                  "PATCH"
                                )
                              }
                            />
                          }
                          label={t(option)}
                        />
                      ))}
                    </FormGroup>
                    {errors.networkRequirement && (
                      <Typography color="error" variant="caption">
                        {errors.networkRequirement}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  <InputLabel
                    sx={{ width: { xs: "100%", md: "50%" }, ...labelStyle }}
                  >
                    {t("Do you have your own cloud infrastructure?")}
                  </InputLabel>
                  <Box>
                    <RadioGroup
                      row
                      name="hasCloudInfrastructure"
                      value={formData.hasCloudInfrastructure}
                      onChange={handleChange}
                      sx={{
                        "& .MuiRadio-root": {
                          color: "#95A0B3",
                        },
                        "& .MuiRadio-root.Mui-checked": {
                          color: "#20A8E0",
                        },
                      }}
                    >
                      <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label={t("Yes")}
                        sx={{ mr: 4 }}
                        disabled={
                          !hasPermission("/api/user/organization", "PATCH")
                        }
                      />
                      <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label={t("No")}
                        disabled={
                          !hasPermission("/api/user/organization", "PATCH")
                        }
                      />
                    </RadioGroup>
                    {errors.hasCloudInfrastructure && (
                      <Typography color="error" variant="caption">
                        {errors.hasCloudInfrastructure}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Grid>

              {formData.hasCloudInfrastructure === "yes" && (
                <Grid item xs={12}>
                  <Box sx={{ pl: { xs: 0, md: "50%" } }}>
                    <InputLabel
                      sx={{
                        fontWeight: "500",
                        fontSize: "0.9rem",
                        mb: 0.5,
                        color: "#333",
                      }}
                    >
                      {t("Tell us more about it:")}
                    </InputLabel>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      name="cloudDetails"
                      value={formData.cloudDetails}
                      onChange={handleChange}
                      error={!!errors.cloudDetails}
                      helperText={errors.cloudDetails}
                      placeholder={t("Please provide details about your cloud infrastructure")}
                      sx={inputStyle}
                      disabled={
                        !hasPermission("/api/user/organization", "PATCH")
                      }
                    />
                  </Box>
                </Grid>
              )}

              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  <InputLabel
                    sx={{
                      width: { xs: "50%", md: "50%" },
                      fontWeight: "500",
                      fontSize: "20px",
                      pr: 1,
                      mt: 1,
                      color: "#414958",
                    }}
                  >
                    {t("Do you need post Go-Live maintenance & support?")}
                  </InputLabel>
                  <Box sx={{ width: { xs: "50%", md: "50%" } }}>
                    <RadioGroup
                      row
                      name="needsSupport"
                      value={formData.needsSupport}
                      onChange={handleChange}
                      sx={{
                        "& .MuiRadio-root": {
                          color: "#95A0B3",
                        },
                        "& .MuiRadio-root.Mui-checked": {
                          color: "#20A8E0",
                        },
                      }}
                    >
                      <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label={t("Yes")}
                        sx={{ mr: 4 }}
                        disabled={
                          !hasPermission("/api/user/organization", "PATCH")
                        }
                      />
                      <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label={t("No")}
                        disabled={
                          !hasPermission("/api/user/organization", "PATCH")
                        }
                      />
                    </RadioGroup>
                    {errors.needsSupport && (
                      <Typography color="error" variant="caption">
                        {errors.needsSupport}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <InputLabel
                    sx={{
                      fontWeight: "500",
                      fontSize: "20px",
                      mb: 1,
                      color: "#414958",
                    }}
                  >
                    {t("Tell us more about your specific needs that we didn't ask!")}
                  </InputLabel>
                  <TextField
                    fullWidth
                    variant="outlined"
                    multiline
                    rows={3}
                    name="specificNeeds"
                    value={formData.specificNeeds}
                    InputProps={{
                      sx: {
                        color: "#111214",
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontStyle: "Medium",
                        fontWeight: 500,
                      },
                    }}
                    onChange={handleChange}
                    placeholder={t("Enter details of your specific needs")}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "16px",
                        border: "1px solid #183059",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                    disabled={!hasPermission("/api/user/organization", "PATCH")}
                  />
                </Box>
              </Grid>

              <Grid item xs={12}>
                {[
                  t("Screens should be procured by you, RouteEye will provide the application integration."),
                  t("You have to procure the GSM SIM cards of any local mobile operator."),
                ].map((note, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    sx={{
                      mb: index < 2 ? 1 : 0,
                      display: "flex",
                      alignItems: "flex-start",
                    }}
                  >
                    <Box component="span" sx={{ mr: 1, color: "#EE3B2B" }}>
                      {index < 1 ? (
                        <img src={LocationPin} alt="" />
                      ) : (
                        <>
                          <img src={LocationPin} alt="" />
                          <img src={LocationPin} alt="" />
                        </>
                      )}
                    </Box>
                    <Box component="span">{note}</Box>
                  </Typography>
                ))}
              </Grid>
            </Grid>
          </Box>

          {actionButtons}
        </Box>
      </Box>

      <RejectModal
        open={rejectModalOpen}
        onClose={() => setRejectModalOpen(false)}
        onConfirm={confirmReject}
        isActionLoading={isActionLoading}
        organizationName={orgNameToReject}
        rejectionReason={rejectionReason}
        setRejectionReason={setRejectionReason}
      />

      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </>
  );
}
